import { EditNote, GetNote, RegisterNote } from "@/dtos/Note.dto";
import { StateObject } from "@/dtos/State.dto";
import Note from "@/services/note";
import {
  CLEAR_NOTE_ISLOADING,
  DELETE_NOTE,
  EDIT_NOTE,
  GET_NOTES,
  REGISTER_NOTE,
} from "@/store/action-types";
import { SET_ERRORMSG, SET_NOTE, SET_NOTES } from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const note: Module<any, {}> = {
  state: {
    note: {
      data: null,
      isLoading: false,
    },
    notes: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    note: (state: { note: any }) => state.note,
    notes: (state: { notes: any }) => state.notes,
  },
  mutations: {
    [SET_NOTE]: (
      state: { note: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.note.data = payload.data;
      state.note.isLoading = payload.isLoading;
    },
    [SET_NOTES]: (
      state: { notes: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.notes.data = payload.data;
      state.notes.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_NOTE]: async ({ commit }: any, payload: any) => {
      commit(SET_NOTE, { data: null, isLoading: true });

      const result: AxiosResponse = await Note.registerNote(payload as RegisterNote);

      if (result) {
        if (result.data.status) {
          commit(SET_NOTE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_NOTE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_NOTE, { isLoading: false });
        return false;
      }
    },
    [GET_NOTES]: async ({ commit }: any, payload: any) => {
      commit(SET_NOTES, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await Note.getNotes(payload as GetNote);

        if (result) {
          if (result.data.status) {
            commit(SET_NOTES, { data: result.data.data, isLoading: false });
            return true;
          }
          commit(SET_NOTES, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_NOTES, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_NOTES, { data: [], isLoading: false });
        commit(SET_ERRORMSG, error.response?.data?.msg || "Failed to fetch notes");
        return false;
      }
    },
    [EDIT_NOTE]: async ({ commit }: any, payload: any) => {
      commit(SET_NOTE, { data: null, isLoading: true });

      const result: AxiosResponse = await Note.editNote(payload as EditNote);

      if (result) {
        if (result.data.status) {
          commit(SET_NOTE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_NOTE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_NOTE, { isLoading: false });
        return false;
      }
    },
    [DELETE_NOTE]: async ({ commit }: any, payload: string) => {
      commit(SET_NOTE, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await Note.deleteNote(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_NOTE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_NOTE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_NOTE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_NOTE_ISLOADING]: ({ commit }) => {
      commit(SET_NOTE, { isLoading: false });
      commit(SET_NOTES, { isLoading: false });
    },
  },
};

export default note;
